import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Browser from './icon-browser.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Browser {...validProps} />;
}
SvgComponent.iconName = 'browser';

/**
 * @deprecated This is a legacy icon
 */
export const BrowserIcon = svgIconWrapper(SvgComponent);
